import Vue from 'vue'
import { Component, Mixins } from 'vue-property-decorator'
import api from '@webparts/api/graph';
import { mapGetters } from 'vuex';
import * as accountTypes from '@account/store/types'

import WebpartTemplate from '@webparts/components/webparts/base/WebpartTemplate.vue'
import WebpartBase from '@webparts/components/webparts/base/WebpartBase'
import { invalidateUrl } from '@appbase/util';

declare global {
    namespace graph {
        export type TeamsGroup = {
            displayName: string;
            description: string;
            id: string;
        };
    }
}



@Component({
    components: {
        WebpartTemplate
    },

    computed: mapGetters({
        user: accountTypes.USER
    })
})
export default class MyTeamsWebpart extends Mixins(WebpartBase) {
    user!: account.User;

    mTeams: graph.TeamsGroup[] = [];

    onTeamClick(team: graph.TeamsGroup) {
        var redirectUrl = invalidateUrl('/cm/Graph/Teams/page/RedirecToTeam')
        window.open(`${redirectUrl}?id=${team.id}`);
    }

    mountAction() {
        this.loading = true;
        api.getMyTeams(this.user.userPrincipalName).then(res => {
            this.mTeams = res;
        }).finally(() => {
            this.loading = false;
        })
    }
    
    created() {
        this.mountAction();
    }
}